import React, { useEffect } from "react";

import InstantQuote from "../InstantQuote/InstantQuote";

import Translation from "./SVG/TranslationCircle.svg";
import Translator from "./SVG/TranslatorCircle.svg";
import Services from "./SVG/ServicesCircle.svg";
import Ecommerce from "./SVG/Ecommerce.svg";
import Business from "./SVG/Business.svg";
import Healthcare from "./SVG/Healthcare.svg";
import Highlight1 from "./SVG/Highlight1.svg";
import Highlight2 from "./SVG/Highlight2.svg";
import JB from "./SVG/JuliusBerger.svg";
import Chi from "./SVG/Chi.svg";
import Coca from "./SVG/CocaCola.svg";
import Icon from "./SVG/Icon.svg";
import BulletSVG from "./SVG/BulletSVG";

import Desktop from "../../images/trustpilot.png";

import "./About.css";
import { Star } from "@material-ui/icons";
import { Link } from "react-router-dom";

const About = () => {
  const typeTranslation = () => {
    const textEng =
      "Oneconverse is an industry leader in language translation and interpreting solutions. leading provider of global services for organisations, businesses, and people that require language translation, interpretation, localization and technology solutions.We’ve been making the world more connected for over 15 years. Oneconverse has a team of professional translators, linguists and engineers with expertise in all corners of the globe, enabling us to provide world-class language translation and technology solutions to clients across the globe.";
    const textDeu =
      "Oneconverse ist ein Branchenführer für Sprachübersetzungs- und Dolmetschlösungen. Führender Anbieter von globalen Dienstleistungen für Organisationen, Unternehmen und Menschen, die Sprachübersetzungen, Dolmetschen, Lokalisierung und Technologielösungen benötigen. Seit über 15 Jahren sorgen wir dafür, dass die Welt besser vernetzt ist. Oneconverse verfügt über ein Team von professionellen Übersetzern, Linguisten und Ingenieuren mit Fachkenntnissen in allen Teilen der Welt, die es uns ermöglichen, Kunden auf der ganzen Welt erstklassige Sprachübersetzungs- und Technologielösungen anzubieten.";
    const textFre =
      "Oneconverse est un leader de I’industrie des solutions de traduction et d’interprretation. C’est un fournisseur de services mondiaux pour les organisations, les entreprises et les personnes qui ont  besoins de traduction, d’interpretation, de localization et de solutions technologiques. Depuis plus de 15 ans, nous rendons le monde plus connecté.Oneconverse dispose d’une équipe de traducteurs professionnels, de linquistes et d’ingénieurs ayant une expertise dans tous les coins du monde, ce qui nous permet de fournir des solutions de traduction et de technologie de classe mondiale à des clients du monde entier.";
    const textChn =
      "Oneconverse 是语言翻译和口译解决方案的行业领导者。为需要语言翻译、口译、本地化和技术解决方案的组织、企业和人员提供全球服务的领先供应商。15 年来，我们一直致力于让世界更加紧密地联系在一起。 Oneconverse 拥有一支由专业翻译人员、语言学家和工程师组成的团队，他们在全球各个角落拥有专业知识，使我们能够为全球客户提供世界一流的语言翻译和技术解决方案。";

    const textElementFre = document.querySelector(".about__us__french");
    const textElementEng = document.querySelector(".about__us__english");

    let currLang_1 = "eng";
    let currLang_2 = "fre";

    const startFunction = () => {
      let charIndexEng = 0;
      let charIndexFre = 0;
      const typingDelay = 20;

      const typeEnglish = () => {
        if (charIndexEng < textEng.length) {
          textElementEng.textContent += textEng.charAt(charIndexEng);
          charIndexEng++;
          setTimeout(typeEnglish, typingDelay);
        } else {
          setTimeout(typeFrench, 500);
        }
      };

      const typeFrench = () => {
        if (charIndexFre < textFre.length) {
          textElementFre.textContent += textFre.charAt(charIndexFre);
          charIndexFre++;
          setTimeout(typeFrench, typingDelay);
        } else {
          setTimeout(langOneLoop, 500);
        }
      };

      typeEnglish();
    };

    const langOneLoop = () => {
      let charIndexEng = 0;
      const typingDelay = 20;
      const erasingDelay = 10;

      const eraseType = (from, to) => {
        let charIndex = from.length - 1;

        if (currLang_1 === "eng") currLang_1 = "deu";
        else currLang_1 = "eng";

        const erase = () => {
          if (charIndex > 0) {
            textElementEng.textContent = from.substring(0, charIndex - 1);
            charIndex--;
            setTimeout(erase, erasingDelay);
          } else {
            setTimeout(type, 1000);
          }
        };

        const type = () => {
          if (charIndexEng < to.length) {
            textElementEng.textContent += to.charAt(charIndexEng);
            charIndexEng++;
            setTimeout(type, typingDelay);
          } else {
            setTimeout(langTwoLoop, 500);
          }
        };

        erase();
      };

      if (currLang_1 === "eng") eraseType(textEng, textDeu);
      else eraseType(textDeu, textEng);
    };

    const langTwoLoop = () => {
      let charIndexFre = 0;
      const typingDelay = 20;
      const erasingDelay = 10;

      const eraseType = (from, to) => {
        let charIndex = from.length - 1;

        if (currLang_2 === "fre") currLang_2 = "chn";
        else currLang_2 = "fre";

        const erase = () => {
          if (charIndex > 0) {
            textElementFre.textContent = from.substring(0, charIndex - 1);
            charIndex--;
            setTimeout(erase, erasingDelay);
          } else {
            setTimeout(type, 1000);
          }
        };

        const type = () => {
          if (charIndexFre < to.length) {
            textElementFre.textContent += to.charAt(charIndexFre);
            charIndexFre++;
            setTimeout(type, typingDelay);
          } else {
            setTimeout(langOneLoop, 500);
          }
        };

        erase();
      };

      if (currLang_2 === "fre") eraseType(textFre, textChn);
      else eraseType(textChn, textFre);
    };

    startFunction();
  };

  const completeEnglish = () => {
    const text =
      " We provide high-quality services at an affordable cost across the globe, so that everyone can communicate in their native language with ease.";
    const typingDelay = 60;
    let charIndex = 0;

    const type = () => {
      const textElement = document.querySelector("#about__complete__english");
      if (textElement && charIndex < text.length) {
        textElement.textContent += text.charAt(charIndex);
        charIndex++;
        setTimeout(type, typingDelay);
      }
    };

    setTimeout(type, 20);
  };

  const completeFrench = () => {
    const text =
      " Nous fournissions des services de haute qualité à un coût abordable dans le monde entier, afin que chacun puisse communiquer facilement dans sa langue maternelle.";
    const typingDelay = 60;
    let charIndex = 0;

    const type = () => {
      const textElement = document.querySelector("#about__complete__french");
      if (textElement && charIndex < text.length) {
        textElement.textContent += text.charAt(charIndex);
        charIndex++;
        setTimeout(type, typingDelay);
      }
    };

    setTimeout(type, 20);
  };

  const popIndustries = () => {
    const ecommerce = document.querySelector("#about__us__ecommerce");
    const business = document.querySelector("#about__us__business");
    const healthcare = document.querySelector("#about__us__healthcare");

    setInterval(() => {
      ecommerce.style.cssText = "transform: scale(1.2)";
      setTimeout(() => {
        ecommerce.style.cssText = "transform: scale(1)";
      }, 500);
      setTimeout(() => {
        business.style.cssText = "transform: scale(1.2)";
      }, 1000);
      setTimeout(() => {
        business.style.cssText = "transform: scale(1)";
      }, 1500);
      setTimeout(() => {
        healthcare.style.cssText = "transform: scale(1.2)";
      }, 2000);
      setTimeout(() => {
        healthcare.style.cssText = "transform: scale(1)";
      }, 2500);
    }, 5000);
  };

  useEffect(() => {
    const translatorParagraph = document.querySelector(
      ".about__us__translator"
    );
    const englishText = document.querySelector("#about__complete__english");
    const frenchText = document.querySelector("#about__complete__french");

    const options = {
      threshold: 0.5,
      rootMargin: "0px",
    };

    const observerTranslation = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            translatorParagraph.style.cssText =
              "color: #fff; text-shadow: none;";
          } else {
            translatorParagraph.style.cssText =
              "color: transparent;text-shadow: 10px 10px 20px #ff5e15;";
          }
        });
      },
      options
    );

    const observerEnglish = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(completeEnglish, 20);
          observerEnglish.disconnect();
        }
      });
    });

    const observerFrench = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(completeFrench, 20);
          observerFrench.disconnect();
        }
      });
    });

    observerTranslation.observe(translatorParagraph);
    observerEnglish.observe(englishText);
    observerFrench.observe(frenchText);
  }, []);

  useEffect(() => {
    typeTranslation();
    popIndustries();
  }, []);

  return (
    <>
      <div className="about container bg-dark">
        <div className="about__rating d-flex gap-40 justify-center">
          <img src={Desktop} alt="" />
          <div className="d-flex flex-column justify-center">
            <h2 className="font-large font-heavy">
              Oneconverse is rated{" "}
              <span className="d-block font-subhead font-bold">Excellent</span>
            </h2>
            <div className="my-20 font-big font-heavy">
              Based on 1200 reviews
            </div>
            <div className="about__stars d-flex align-center gap-10 my-10">
              <div className="d-flex align-center justify-center">
                <Star />
              </div>
              <div className="d-flex align-center justify-center">
                <Star />
              </div>
              <div className="d-flex align-center justify-center">
                <Star />
              </div>
              <div className="d-flex align-center justify-center">
                <Star />
              </div>
              <div className="d-flex align-center justify-center">
                <Star />
              </div>
            </div>
            <div className="about__trustpilot py-20 d-flex align-center">
              <Star />
              <span className="font-large ml-10">Trustpilot</span>
            </div>
          </div>
        </div>
        <div className="about__us">
          <h2 className="blue-text-clip font-large">
            Let's communicate in one language
          </h2>
          <ul className="position-relative list-none my-40 pl-40">
            <li className="position-relative w-100">
              <BulletSVG />
              <div className="">
                <div className="d-flex flex-column justify-end">
                  <div className="about__us__orange__line"></div>
                  <p className="about__us__english lh-lg font-heavy font-sm"></p>
                  <div className="about__us__orange__line mt-40 about__us__push__right"></div>
                  <p className="about__us__french lh-lg font-heavy font-sm about__us__push__right"></p>
                </div>
                <img src={Translation} alt="translation" />
              </div>
              <Link
                to="/languages"
                className="about__us__primary__btn font-bold py-10 px-40 mt-40 curved-20 border-0 outline-0"
              >
                SEE LANGUAGES
              </Link>
            </li>
            <li className="position-relative w-100">
              <BulletSVG />
              <div className="about__translator d-flex flex-row-reverse align-center">
                <div className="d-flex flex-column justify-start">
                  <div className="about__us__orange__line"></div>
                  <p className="about__us__translator lh-lg font-heavy font-normal">
                    Oneconverse is a global company that provides translation
                    and interpretation services in over 350 languages. The
                    company, which has offices in New York, Missouri, Nigeria,
                    Dubai, Ghana, China, London, Paris, Amsterdam, Berlin and
                    Bucharest. It is one of the best translation companies in
                    the world with the most diverse and versatile translation
                    and interpretation teams in the world, with native speakers
                    in over 350 languages.Oneconverse has set up a global
                    network of over 50000+ professional linguists and operates
                    24/7 with full-time customer support staff. Oneconverse is
                    ranked as one of the best translation services
                  </p>
                </div>
                <img src={Translator} alt="translation" />
              </div>
            </li>
            <li className="position-relative w-100">
              <BulletSVG />
              <div className="">
                <div className="d-flex flex-column justify-end">
                  <h2 className="blue-text-clip font-large">Our Services</h2>
                  <div className="about__us__orange__line"></div>
                  <p
                    style={{ height: "550px" }}
                    className="about__us__english lh-lg font-heavy font-sm"
                  >
                    "Oneconverse is the world’s leading provider of translation
                    and localization services. We offer more than 350 languages
                    and support 100+ countries for client-side and on-demand
                    services.Oneconverse is a complete language service
                    provider, we cover all aspects of language needs – from
                    translation to interpretation to localization – enabling
                    global organizations to communicate with their customers in
                    the way they want.Our team is made up of over 50,000
                    translators, interpreters and localization specialists, who
                    strive to serve all our customers with professionalism and
                    care. Our customer-oriented approach is what sets us apart
                    from other translation providers.&nbsp;
                    <span id="about__complete__english"></span>
                    <span className="blinking__dot"></span>"
                  </p>
                  <div className="about__us__orange__line mt-40 about__us__push__right"></div>
                  <p
                    style={{ height: "550px" }}
                    className="about__us__french lh-lg font-heavy font-sm about__us__push__right"
                  >
                    "Oneconverse est le premier fournisseur mondial de services
                    de traduction et de localisation. Nous proposons plus de 350
                    langues et prenons en charge plus de 100 pays pour des
                    services à la demande et côté client.Oneconverse est un
                    prestataire de services linguistiques complet, nous couvrons
                    tous les aspects des besoins linquistiques – de la
                    traduction à l’interpretation en passant par la localisation
                    – permettant aux organisations internationales de
                    communiquer avec leurs clients de la manière dont ils le
                    souhaitent.Notre équipe est composeé de plus de 50 000
                    traducteurs, interprètes et spécialistes de la localisation,
                    qui s’efforcent de server tous nos clients avec
                    professionnalism et attention. Notre approche axées sur le
                    client est ce qui nous distingue des autres prestataires de
                    services de traductions.&nbsp;
                    <span id="about__complete__french"></span>
                    <span className="blinking__dot"></span>"
                  </p>
                </div>
                <img
                  className="about__services__img"
                  src={Services}
                  alt="translation"
                />
              </div>
              <Link
                to="/services"
                className="about__us__primary__btn font-bold py-10 px-40 mt-40 curved-20 border-0 outline-0"
              >
                SEE SERVICES
              </Link>
            </li>
            <li className="position-relative w-100">
              <BulletSVG />
              <h2 className="blue-text-clip font-large">Industry Coverage</h2>
              <div className="about__us__orange__line"></div>
              <div className="about__us__industies">
                <div className="d-flex flex-column justify-end my-40">
                  <div className="grid c-3 gap-20">
                    <div className="about__us__industry  p-20">
                      <div className="d-flex flex-column align-center">
                        <img id="about__us__ecommerce" src={Ecommerce} alt="" />
                        <span className="py-20 font-bigger font-bold">
                          E-Commerce
                        </span>
                      </div>
                      <p className="font-big text-left font-heavy">
                        Oneconverse provides translation services to e-commerce
                        businesses. We have a team of accurate translators and
                        localization experts who will translate your store.{" "}
                      </p>
                    </div>
                    <div className="about__us__industry  p-20">
                      <div className="d-flex flex-column align-center">
                        <img id="about__us__business" src={Business} alt="" />
                        <span className="py-20 font-bigger font-bold">
                          Business
                        </span>
                      </div>
                      <p className="font-big text-left font-heavy">
                        The Oneconverse team has a deep knowledge of what it
                        takes to be successful when translating products to
                        different markets, and we have teams to make it happen.{" "}
                      </p>
                    </div>
                    <div className="about__us__industry  p-20">
                      <div className="d-flex flex-column align-center">
                        <img
                          id="about__us__healthcare"
                          src={Healthcare}
                          alt=""
                        />
                        <span className="py-20 font-bigger font-bold">
                          Healthcare
                        </span>
                      </div>
                      <p className="font-big text-left font-heavy">
                        Oneconverse offers translation and interpretation
                        solutions for the healthcare industry including
                        research, medical records, patient information, and
                        more.
                      </p>
                    </div>
                  </div>
                  <Link
                    to="/industries"
                    className="about__us__primary__btn about__us__btn__last mx-auto font-bold py-10 px-40 mb-20 mt-40 curved-20 border-0 outline-0"
                  >
                    SEE INDUSTRIES
                  </Link>
                </div>
              </div>
            </li>
          </ul>
          <div>
            <h2 className="blue-text-clip font-large">
              Highlights of Our Process
            </h2>
            <div className="about__us__orange__line"></div>
            <ul className="position-relative list-none my-40">
              <li className="position-relative w-100">
                <div className="d-flex align-center justify-between">
                  <img src={Highlight1} alt="translation" className="d-block" />
                  <div className="d-flex flex-column justify-end">
                    <div className="py-20">
                      <h4 className="d-flex align-center font-bigger">
                        <img src={Icon} alt="icon" className="mr-10" />
                        Documents Upload
                      </h4>
                      <p className="font-big font-heavy py-20">
                        Document to be translated is uploaded, scrutinized,
                        evaluated, properly and securely saved for usage in
                        further process.
                      </p>
                    </div>
                    <div className="py-20">
                      <h4 className="d-flex align-center font-bigger">
                        <img src={Icon} alt="icon" className="mr-10" />
                        Allocation of Project
                      </h4>
                      <p className="font-big font-heavy py-20">
                        Most qualified, highly rated and project specific
                        translator is sorted and allocated the project, Our
                        translators are timely and do not cause any delay.
                      </p>
                    </div>
                  </div>
                </div>
              </li>
              <li className="position-relative w-100 mt-40">
                <div className="d-flex flex-row-reverse align-center justify-between">
                  <img src={Highlight2} alt="translation" className="d-block" />
                  <div className="d-flex flex-column justify-end">
                    <div className="py-20">
                      <h4 className="d-flex align-center font-bigger">
                        <img src={Icon} alt="icon" className="mr-10" />
                        Translation of Documents
                      </h4>
                      <p className="font-big font-heavy py-20">
                        The actual translation is done here with careful
                        attention to the specifics of the project, carrying
                        along the tone, emotions, etc along to ensure most
                        accurate translation.
                      </p>
                    </div>
                    <div className="py-20">
                      <h4 className="d-flex align-center font-bigger">
                        <img src={Icon} alt="icon" className="mr-10" />
                        Quality Assurance
                      </h4>
                      <p className="font-big font-heavy py-20">
                        The project translated is subjected to rigid scrutiny
                        and careful vetting to ensure the quality and standard
                        of OneConverse is maintained, paying close attention to
                        details.
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div className="about__us__client d-flex align-center justify-between f-100 gap-20">
            <div className="f-100">
              <div className="about__us__orange__line"></div>
              <p className="font-bigger font-bolder">
                See our pool of over 100 clients that choose us and has stayed
                with us
              </p>
            </div>
            <div className="d-flex align-center justify-between f-100">
              <img src={JB} alt="Julius Berger" />
              <img src={Chi} alt="Chi" />
              <img src={Coca} alt="Coca Cola" />
            </div>
          </div>
          <div className="container">
            <InstantQuote black />
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
